import Vue from "vue";
import i18n from "@/plugins/i18n";
import axios from "@/helpers/axios";
import router from "@/router";

const user = JSON.parse(localStorage.getItem("sprkr/user"));
const state = user ? { loggedIn: true, user } : { loggedIn: false, user: null };

export default {
  namespaced: true,
  state,
  mutations: {
    SET_USER(state, data) {
      state.loggedIn = data ? true : false;
      let user = { ...state.user, ...data };
      state.user = user;
      localStorage.setItem("sprkr/user", JSON.stringify(user));
    },
    REMOVE_USER(state) {
      state.loggedIn = false;
      state.user = null;
      localStorage.removeItem("sprkr/user");
    }
  },
  actions: {
    changePassword(_, postData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/auth/password/change/`, postData)
          .then(({ data }) => {
            // commit("SET_BOX", data);
            Vue.notify({
              type: "success",
              group: "alert",
              title: i18n.t("success"),
              text: i18n.t("Password updated!")
            });
            resolve(data);
          })
          .catch(err => {
            const { data } = err.response;
            let message = Object.keys(data).reduce((accu, key) => {
              let res = "";
              data[key].forEach(item => {
                res = `${res} ${item}`;
              });
              accu += res;
              return accu;
            }, "");
            Vue.notify({
              type: "error",
              group: "alert",
              title: i18n.t(`password reset errors`),
              text: message
            });
            reject(err);
          });
        // .finally(() => {
        //   // commit("SET_LOADING_STATUS", { entity, status: false });
        // });
      });
    },
    uploadUserImage({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/users/user-image-upload/`, formData)
          .then(({ data }) => {
            commit("SET_USER", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
        // .finally(() => {
        //   // commit("SET_LOADING_STATUS", { entity, status: false });
        // });
      });
    },
    async getProfile({ commit }) {
      try {
        const { data } = await axios.get(`/users/user-profile/`);
        commit("SET_USER", data);
      } catch (err) {
        commit("REMOVE_USER", err);
      }
    },
    updateUserProfile({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/users/user-profile/`, formData)
          .then(({ data }) => {
            commit("SET_USER", data);
            Vue.notify({
              type: "success",
              group: "alert",
              title: i18n.t("success"),
              text: i18n.t("Profile updated!")
            });
            resolve(data);
          })
          .catch(error => {
            Vue.notify({
              type: "error",
              group: "alert",
              title: i18n.t("error"),
              text: i18n.t("Please try again")
            });
            reject(error);
          });
        // .finally(() => {
        //   // commit("SET_LOADING_STATUS", { entity, status: false });
        // });
      });
    },
    passwordReset(_, postData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/auth/password/reset/confirm/`, postData)
          .then(({ data }) => {
            Vue.notify({
              type: "success",
              group: "alert",
              title: i18n.t("success"),
              text: i18n.t("Password Reset success")
            });
            resolve(data);
          })
          .catch(error => {
            Vue.notify({
              type: "error",
              group: "alert",
              title: i18n.t("error"),
              text: i18n.t("Password Reset error")
            });
            reject(error);
          });
      });
    },
    forgetPasswordReset(_, postData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/auth/password/reset/`, postData)
          .then(({ data }) => {
            Vue.notify({
              type: "success",
              group: "alert",
              title: i18n.t("Password Reset sent"),
              text: i18n.t("Please check your email!")
            });
            resolve(data);
          })
          .catch(error => {
            Vue.notify({
              type: "error",
              group: "alert",
              title: i18n.t("Password Reset error"),
              text: i18n.t("Please check the email entered")
            });
            reject(error);
          });
      });
    },
    async socialLogin({ commit }, { provider, token }) {
      try {
        const { data } = await axios.post(`/auth/${provider}/`, {
          access_token: token
        });
        commit("SET_USER", data);
        const { query } = router.currentRoute;
        const nextUrl = query && query.nextUrl ? query.nextUrl : "/";
        router.push(nextUrl);
      } catch (err) {
        Vue.notify({
          type: "error",
          group: "alert",
          title: i18n.t("login failed"),
          text: i18n.t("Please check the creditials")
        });
        commit("REMOVE_USER", err);
      }
    },
    async login({ commit }, creds) {
      try {
        const { data } = await axios.post(`/auth/login/`, creds);
        commit("SET_USER", data);
        const { query } = router.currentRoute;
        const nextUrl = query && query.nextUrl ? query.nextUrl : "/";
        router.push(nextUrl);
      } catch (err) {
        Vue.notify({
          type: "error",
          group: "alert",
          title: i18n.t("login failed"),
          text: i18n.t("Please check the creditials")
        });
        commit("REMOVE_USER", err);
      }
    },
    async logout({ commit }) {
      commit("REMOVE_USER");
      await axios.post(`/auth/logout/`);
      router.push("/");
    },
    async register({ commit }, formData) {
      try {
        const data = await axios.post(`/auth/registration/`, formData);
        commit("SET_USER", data);
        router.push("/registered");
      } catch (err) {
        const { data } = err.response;
        let message = Object.keys(data).reduce((accu, key) => {
          let res = "";
          data[key].forEach(item => {
            res = `${res} ${item}`;
          });
          accu += res;
          return accu;
        }, "");
        Vue.notify({
          type: "error",
          group: "alert",
          title: i18n.t(`registration errors`),
          text: i18n.t(`${message}`)
        });
        commit("REMOVE_USER", err);
      }
    }
  }
};
